import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-multi-team-fundraising',
    templateUrl: './multi-team-fundraising.component.html',
    styleUrls: ['./multi-team-fundraising.component.scss'],
    standalone: true,
    imports: [FlexModule, NgClass, ExtendedModule, MatButtonModule, MatCardModule]
})
export class MultiTeamFundraisingComponent {
	whydonatePlatformUrl = $localize`:@@header_crowfunding_label:crowdfunding-fundraising`;

	constructor() {}

	ngOnInit(): void {}
	languageForWhydonatePlatform() {
		window.location.href = 'https://whydonate.com/' + this.whydonatePlatformUrl;
	}
}
